import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import { SupabaseContextService } from "../server/supabase-context-service";

export const useAccountIndustry = (): UseSupabaseLoaderState<string | null> => {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    return await new SupabaseContextService(supabase).getValue(account_id, "industry");
  }, []);
};
